import { Record } from "immutable";
import {
  DEVICE_WIRINGS,
  DEVICE_DEMAND_METHODS,
  DEVICE_DEMAND_INTERVALS,
  DEVICE_MAIN_SELS,
  DEVICE_CONFIG_STATUS,
  DEVICE_BR_VALUES,
  DEVICE_PARITY_VALUES,
  DEVICE_STOP_VALUES
} from "src/infinode/constants/device";
import moment from "moment";

const DeviceConfigRecord = Record({
  lastUpdatedTime: null, // moment
  status: DEVICE_CONFIG_STATUS.UPDATED,
  // Properties
  wiringU: null,
  Wiring_I123: null,
  Wiring_I456: null,
  wiringI:null,
  InSource :null,
  CT113Primary:null,
  CT113Secondary :null,
  CT113Reverse:null,
  CT2Primary :null,
  CT2Secondary: null,
  CT2Reverse: null,
  CT3Primary: null,
  CT3Secondary: null,
  CT3Reverse: null,
  CTInPrimary: null,
  CTInSecondary: null,
  CTInReverse: null,

  mainCircuit: DEVICE_MAIN_SELS.OFF,

  PTPrimary: null,
  PTPrimaryUnit:null,
  PTSecondary:null,

  pulse: null,
  
  demandMode: DEVICE_DEMAND_METHODS.SLIDING,
  demandInterval: DEVICE_DEMAND_INTERVALS.THIRTY_MINS,
  DI1Setup:null,
  DI2Setup:null,
  rs485Baudrate: null,
  rs485Parity: null,
  rs485Stopbit: null,
  rs485Addr:null,
  Telemetryinterval1: 15,
  Telemetryinterval2: 900,
  Telemetryinterval3: 3600,
  Peripherals: [], // 0xFF ? Hex ?
  
  sldRole:null,
  allowedDemand:null,
  demandLimit : null,
  demandUnit : null,
  demandSafeMargin : null,
  smartLoadLowOffset : null,
  smartLoadUnit : null,
  smartLoadSafeMargin : null,
  loadEnableMask : null,
  evChargerEnableMask : null,
  demandControlSequence : null,
  smartLoadSequence : null,
  smartLoadTurnOffThresholdMask : null,
  smartLoad1TurnOffThreshold : null,
  smartLoad2TurnOffThreshold : null,
  smartLoad3TurnOffThreshold : null,
  smartLoad4TurnOffThreshold : null,
  smartLoad5TurnOffThreshold : null,
  demandControlDecisionTime : null,
  smartLoaddecisionTime : null,
  exportLimit : null,
  exportUnit : null,
  exportSafeMargin : null,
  sldRole : null,
  sldRoleLastUpdatedTsSec : null,
  loadDeadBandFactor : null,
  mainCircuitAllocationLevel1 : null,
  mainCircuitAllocationLevel2 : null,
  load1CircuitAllocationLevel1 : null,
  load1CircuitAllocationLevel2 : null,
  load1RatedkW : null,
  load1RatedkVA : null,
  load2CircuitAllocationLevel1 : null,
  load2CircuitAllocationLevel2 : null,
  load2RatedkW : null,
  load2RatedkVA : null,
  load3CircuitAllocationLevel1 : null,
  load3CircuitAllocationLevel2 : null,
  load3RatedkW : null,
  load3RatedkVA : null,
  load4CircuitAllocationLevel1 : null,
  load4CircuitAllocationLevel2 : null,
  load4RatedkW : null,
  load4RatedkVA : null,
  solar1Brand : null,
  solar1Model : null,
  solar1FirmwareVersion : null,
  solar1AddrIPV4 : null,
  solar1AddrSerial : null,
  solar1Port : null,
  solar1Protocol : null,
  solar1CircuitAllocationLevel1 : null,
  solar1CircuitAllocationLevel2 : null,
  solar1RatedkW : null,
  solar1RatedkVA : null,
  solar1Setpoint : null,
  solar1SetpointUnit : null,
  ismaster:null,
  masterGlobalUniqueID:null


});

const extractConfigObjToRecord = (origRecord, configObj) =>
  origRecord.withMutations(rm => {
    rm.set("status", configObj.status);
    rm.set("lastUpdatedTime", moment(configObj.lastUpdatedTime));
    configObj.forEach(pObj => {
      Object.keys(pObj).forEach(key=>{
        if (origRecord.has(key)){
          rm.set(key, pObj[key]);
        }
        
      });
      
    });
  });

// const extractConfigObjToRecord = (origRecord, configObj) =>
//   origRecord.withMutations(rm => {
//     rm.set("status", configObj.status);
//     rm.set("lastUpdatedTime", moment(configObj.lastUpdatedTime));
//     configObj.forEach(pObj => {
//       // Assuming pObj is an object with {propertyKey, propertyValue}
//       Object.keys(pObj).forEach(key => {
//         rm.set(key, pObj[key]);
//       });
//     });
//   });




const createDeviceConfigRecord = configObj => {
  let record = DeviceConfigRecord();
  console.log("configObj:", configObj);
  return extractConfigObjToRecord(record, configObj);
};

const updateDeviceConfigRecord = configObj => origConfigRecord => extractConfigObjToRecord(origConfigRecord, configObj);

export { createDeviceConfigRecord, updateDeviceConfigRecord };

export default DeviceConfigRecord;
